import { SVGProps, Ref, forwardRef } from 'react';

export const DrawerFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M5.75 1C2.567 1 1.4 2.906.72 8.09q-.036.278-.067.542h4.664l.5 1.333h4.362l.5-1.333h4.668q-.03-.264-.067-.542C14.6 2.906 13.433 1 10.25 1z"
                fill="currentColor"
            />
            <path
                d="M15.472 10.03h-3.823l-.5 1.334H4.847l-.5-1.333H.528C.314 13.714 1.312 15 4.058 15h7.883c2.747 0 3.745-1.287 3.531-4.97"
                fill="currentColor"
            />
        </g>
    </svg>
));
DrawerFilledSize16Glyph.displayName = 'DrawerFilledSize16Glyph';
